import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import CaseStudy from '@src/components/DisposalPage/CaseStudy'
import FAQ from '@src/components/DisposalPage/FAQ'
import SustainabilityDashboardPromo from '@src/components/DisposalPage/SustainabilityDashboardPromo'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/ppe-disposal-page.module.css'
// eslint-disable-next-line import/extensions
import ppeDisposal from '../../json/ppe-disposal-data.json'

const ppeServiceData = {
  name: 'PPE Disposal and Recycling',
  description:
    'Bulk PPE disposal and recycling for businesses, healthcare, and government. Dimension removes expired, surplus, and recalled masks, gloves, gowns, and face shields, with donation of usable stock and full documentation.',
  serviceType: 'PPE Disposal and Recycling',
  url: 'https://getdimension.com/ppe-disposal',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: 'Disposable Mask and Respirator Disposal' },
    { name: 'Glove and Gown Disposal' },
    { name: 'Face Shield and Goggle Disposal' },
    { name: 'Expired and Recalled PPE Removal' },
    { name: 'Surplus PPE Donation and Recycling' },
  ],
}

const ppeFAQData = {
  questions: ppeDisposal.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' '),
  })),
}

function PpeDisposal() {
  return (
    <>
      <Head>
        <title>PPE Disposal &amp; Recycling for Businesses | Dimension</title>
        <meta
          name="description"
          content="Bulk PPE disposal and recycling for businesses, healthcare, and government. Dimension removes expired, surplus & recalled masks, gloves, and gowns, from around $50 per pallet, with donation and documentation."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/ppe-disposal" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={ppeServiceData} />
        <SchemaMarkup type="FAQPage" data={ppeFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heroImage="hand-sanitizer"
          heading={ppeDisposal.pitch.heading}
          material={ppeDisposal.pitch.material}
          pitchText={ppeDisposal.pitch.pitchText}
          ctaLink={ppeDisposal.pitch.ctaLink}
          ctaText={ppeDisposal.pitch.ctaText}
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Clients />
        <FeatureList {...ppeDisposal.solutions} />
        <SustainabilityDashboardPromo />
        <FeatureList {...ppeDisposal.benefits} />
        <CaseStudy {...ppeDisposal.caseStudy} />
        <Approach {...ppeDisposal.approach} />
        <FAQ {...ppeDisposal.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'Hand Sanitizer Disposal',
              href: '/hand-sanitizer-disposal',
              description:
                'Compliant bulk disposal of expired, surplus, and recalled hand sanitizer for businesses.',
            },
            {
              label: 'Hand Sanitizer Recycling',
              href: '/hand-sanitizer-recycling',
              description:
                'Recycle expired hand sanitizer through ethanol reclamation and donation of usable surplus.',
            },
            {
              label: 'Sustainability',
              href: '/sustainability',
              description:
                'Learn how Dimension diverts waste from landfills through recycling and responsible disposal.',
            },
            {
              label: 'Business Waste Solutions',
              href: '/b2b-solutions',
              description:
                'Customized waste management for enterprises with dedicated reporting and account management.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default PpeDisposal
